import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

interface EditingDocumentsStatusResponse {
  status: string;
}

/**
 * GET 상태 조회
 */
export function getEditingDocumentsStatus(
  workspaceId: string,
  editingDocumentId: string
): Promise<EditingDocumentsStatusResponse> {
  return requestApi<EditingDocumentsStatusResponse>({
    url: withDocument(`/workspaces/${workspaceId}/editing-documents/${editingDocumentId}/status`),
    method: 'GET',
    credentials: true,
  }).then((response) => response.data);
}
